import { OURVEHICLE_GET_LIST } from "../../../redux/contants";

// eslint-disable-next-line import/prefer-default-export
export const getOurVehicle = (data) => ({
    type: OURVEHICLE_GET_LIST,
    payload: data
});
